import { render, staticRenderFns } from "./Asset-Stock.vue?vue&type=template&id=381f7281"
import script from "./Asset-Stock.vue?vue&type=script&lang=js"
export * from "./Asset-Stock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports